import { render, staticRenderFns } from "./DocumentSeriesAllocationListTable.vue?vue&type=template&id=4cd496b5&"
import script from "./DocumentSeriesAllocationListTable.vue?vue&type=script&lang=js&"
export * from "./DocumentSeriesAllocationListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports